import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import dayjs from "dayjs";

const PapeletaModal = ({ modal, setModal }) => {
  const [loading, setLoading] = useState(false);
  const [salidas, setSalidas] = useState(modal.salidas);
  console.log(modal.salidas);
  const handleClose = () => {
    setModal({ ...modal, papeleta: false, update: false });
  };

  return (
    <div>
      <Modal isOpen={modal.papeleta} className="modal-dialog modal-xl">
        <ModalHeader className="bg-primary">
          Papeleta #{modal.unidad["number"]} Fecha {modal.date}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            {salidas.map((s, idx) => (
              <div className="table-responsive" key={s.id}>
                <p>
                  <b>Vuelta {idx + 1}</b> | Salida: {s.no} | Hora Salida:{" "}
                  <b style={{ color: "red" }}>{s.hora}</b> | Destino:{" "}
                  {s.destination} | Operador: {s.operator_name}
                </p>
                <table width="100%">
                  <thead>
                    <tr align="center">
                      <th>Geocercas</th>
                      {s.tiempos.map((g) => (
                        <th key={g.id}>{g.geofence_name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr align="center">
                      <th>Bitacora</th>
                      {s.tiempos.map((g) => (
                        <td key={g.id}>
                          {g.tiempo_propuesto ?? 'Sin Dato'}
                        </td>
                      ))}
                      <td></td>
                    </tr>
                    <tr align="center">
                      <th>Tiempo Real</th>
                      {s.tiempos.map((g) => (
                        <td key={g.id} className={g.quemadas ? 'bg-danger text-white' : ''}>
                          { g.tiempo_real
                            ? g.tiempo_real
                            : "Sin Dato"}
                            <br />
                            {g.quemadas ? '+' + g.diferencia : '-'}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
                <br />
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            <i className="fas fa-times"></i> &nbsp; Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PapeletaModal;
